import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { AppProvider, useApp } from "./context/AppContext";
import OnboardingOverlay from "./components/OnboardingOverlay";

// Pages
import Home from "./pages/Home";
import Practice from "./pages/Practice";
import IntervalPractice from "./pages/IntervalPractice";
import Summary from "./pages/Summary";
import Settings from "./pages/Settings";
import Progress from "./pages/Progress";

// App content with context access
function AppContent() {
  const { onboardingComplete, completeOnboarding } = useApp();
  
  return (
    <>
      {!onboardingComplete && (
        <OnboardingOverlay onComplete={completeOnboarding} />
      )}
      <AnimatePresence mode="wait">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/practice" element={<Practice />} />
          <Route path="/practice/intervals" element={<IntervalPractice />} />
          <Route path="/summary" element={<Summary />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/progress" element={<Progress />} />
        </Routes>
      </AnimatePresence>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppProvider>
          <AppContent />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
